import styled from 'styled-components';

const HeroAboutStyle = styled.section`
	--distanceTitleDescription: var(--sp3x);
	--sizeImage: 37.73%;

	position: relative;
	overflow: hidden;

	.wrapper-title-description {
		position: absolute;
		height: 100%;
		width: 100%;
		top: 0;
		z-index: 1;
	}

	.info-wrapper {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		height: 100%;
		width: 100%;
	}

	.inner-wrapper {
		display: flex;
		flex-direction: column;
		gap: var(--distanceTitleDescription);
	}

	.image-cont {
		--proportion: var(--sizeImage);
	}

	.wrapper-image {
		transform: scale(0);
		opacity: 0.75;
	}

	.description {
		transform: translateX(calc(-100% - var(--contPaddingLR)));
		/* display: -webkit-box;
		-webkit-line-clamp: 7;
		-webkit-box-orient: vertical;
		overflow: hidden; */
	}
	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--sizeImage: 36.75%;
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--sizeImage: 43.4%;
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--sizeImage: 44.42%;
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--sizeImage: 41.11%;
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--sizeImage: 47.545%;
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--sizeImage: 137.84%;

		.info-wrapper {
			justify-content: flex-end;
			padding-bottom: var(--sp6x);
		}
	}
`;
export default HeroAboutStyle;
